import React from "react";
import { Card, Row, Col, Button, Typography, Space, Breadcrumb, Tag, Flex } from "antd";
import { 
  MobileOutlined, 
  DesktopOutlined, 
  EditOutlined,
  ClockCircleOutlined
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;
const { Meta } = Card;

const FanTemplate = () => {


  return (
    <div className="fan-template-page">
      <Flex
        gap="middle"
        align="center"
        justify="space-between"
        className="page-header"
      >
        <h2>Fan Templates</h2>
        <Breadcrumb
          items={[
            {
              title: "Home",
            },
            {
              title: "Create",
            },
            {
              title: <a href="/badge-editor">Fan Templates</a>,
            },
          ]}
        />
      </Flex>


      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          <Card
            hoverable
            style={{ height: "100%", marginTop: "20px" }}
            cover={
              <div style={{ height: "200px", backgroundColor: "#e6f7ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <DesktopOutlined style={{ fontSize: "80px", color: "#52c41a" }} />
              </div>
            }
            actions={[
              <Link to="/landing-editor-desktop" key="edit">
                <Button type="default" icon={<EditOutlined />}>
                  Edit
                </Button>
              </Link>
            ]}
          >
            <Meta
              title="Desktop Template"
              description="Desktop template optimized for large screens."
            />
           
          </Card>
        </Col>
        
        <Col xs={24} md={12}>
          <Card
            hoverable
            style={{ height: "100%", marginTop: "20px" }}
            cover={
              <div style={{ height: "200px", backgroundColor: "#f9f0ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MobileOutlined style={{ fontSize: "80px", color: "#722ed1" }} />
              </div>
            }
            actions={[
              <Link to="/landing-editor" key="edit">
                <Button type="default" icon={<EditOutlined />}>
                  Edit
                </Button>
              </Link>
            ]}
          >
            <Meta
              title="Mobile Template"
              description="Mobile template optimized for small screens."
            />
      
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default FanTemplate; 